module.exports = __webpack_public_path__ + "static/media/209-indonesia.e63571c5.svg";